import { render, staticRenderFns } from "./ModalFormularioConfiguracionesPagos.vue?vue&type=template&id=336a3fe3"
import script from "./ModalFormularioConfiguracionesPagos.vue?vue&type=script&lang=js"
export * from "./ModalFormularioConfiguracionesPagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports